<div class="app-main">
  <div class="app-breadcrumb">
    <span class="bc-link" (click)="goBack()">Empresas</span>
    <span class="bc-sep">›</span>
    <span class="bc-current">{{ company()?.name || 'Sucursales' }}</span>
  </div>

  <h1 class="page-title">Sucursales</h1>
  <p class="page-subtitle">Selecciona una sucursal para ver su dashboard</p>

  @if (loading()) {
    <div class="loading-state">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p>Cargando sucursales...</p>
    </div>
  } @else if (error()) {
    <div class="empty-state">
      <p class="text-danger">{{ error() }}</p>
    </div>
  } @else if (branches().length === 0) {
    <div class="empty-state">
      <p>No hay sucursales registradas.</p>
    </div>
  } @else {
    <div class="card-grid">
      @for (branch of branches(); track branch.idBranch) {
        <div class="entity-card" (click)="goToDashboard(branch)">
          <div class="entity-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6-.354.353V16h4.5v-4.5h5V16H15V7.5l-.354-.354-6-6z"/>
            </svg>
          </div>
          <p class="entity-name">{{ branch.name }}</p>
          <p class="entity-meta">Ver dashboard →</p>
        </div>
      }
    </div>
  }
</div>
